import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/tc_subscribe.png'


const _withScopeId = n => (_pushScopeId("data-v-1e75823b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content tc-subscribe-popup" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "tc_subscribe",
  class: "tc-subscribe-popup-img"
}, null, -1))
const _hoisted_4 = { class: "tc-subscribe-popup-checkbox" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 오늘 하루 보지 않기 ")
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" 광고성 정보 수신 동의하고, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 캠페인 소식을 가장 먼저 받아보세요! ")
], -1))
const _hoisted_8 = { class: "jump-button" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 확인하러 가기 ")

import { ref, onMounted, watchEffect, computed } from 'vue';
import { Modal } from 'bootstrap';
import { useRoute } from 'vue-router';
import { authStore } from '@/stores';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const TC_SUBSCRIBE_KEY = 'tc_subscribe_popup_today';

const route = useRoute();
const modalRef = ref();
let modalInstance: Modal;
const userKnowDate = ref(localStorage.getItem(TC_SUBSCRIBE_KEY));
const isSameDay = computed(() => {
  return userKnowDate.value && dayjs(userKnowDate.value).isSame(dayjs(), 'day');
});

onMounted(() => {
  // 如果是同一天，不弹窗
  if (isSameDay.value) {
    return;
  }
  modalInstance = new Modal(modalRef.value, {
    keyboard: true,
    backdrop: 'static'
  });
});


function handleClose() {
  if (!modalInstance) {
    return;
  }
  modalInstance.hide();
}
const whiteList = ['mine.tcSubscribe', 'mine.memberProfile.edit', 'marketingConsent'];
watchEffect(() => {
  if (!authStore.user?.id || isSameDay.value) {
    return;
  }
  const subscribe = authStore.user?.subscribe_tc_information;
  if (whiteList.includes(route.name as string)) {
    handleClose();
  } else if (!subscribe) {
    modalInstance && modalInstance.show();
  }
});

const userKnowToday = ref(false);

function handleCheckboxChange() {
  if (userKnowToday.value) {
    const today = dayjs().format('YYYY-MM-DD');
    localStorage.setItem(TC_SUBSCRIBE_KEY, today);
    userKnowDate.value = today;
    handleClose();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modalRef",
    ref: modalRef,
    class: "modal fade"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_b_form_checkbox, {
            modelValue: userKnowToday.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userKnowToday).value = $event)),
            value: true,
            onChange: handleCheckboxChange
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: handleClose
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, { to: "/mine/tc_subscribe" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 512))
}
}

})